import { render, staticRenderFns } from "./offers.vue?vue&type=template&id=9ae7cf92&"
import script from "./offers.vue?vue&type=script&lang=js&"
export * from "./offers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ae7cf92')) {
      api.createRecord('9ae7cf92', component.options)
    } else {
      api.reload('9ae7cf92', component.options)
    }
    module.hot.accept("./offers.vue?vue&type=template&id=9ae7cf92&", function () {
      api.rerender('9ae7cf92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SwBIqHg4LGK4/JS/comp/offers.vue"
export default component.exports